import React from 'react';

import { SettingsSaveBarProps } from './SettingsSaveBar';
import { SettingsSaveBarSetterContext } from './SettingsSaveBarContext';

/** Shows Cancel and Save changes in the settings page header while the calling page is mounted. */
export const useSettingsSaveBar = ({
  dirty,
  saving,
  onSave,
  onCancel,
}: SettingsSaveBarProps) => {
  const setSaveBar = React.useContext(SettingsSaveBarSetterContext);

  // Layout effects so the bar is in place before the page paints.
  React.useLayoutEffect(() => {
    setSaveBar({ dirty, saving, onSave, onCancel });
  }, [dirty, saving, onSave, onCancel, setSaveBar]);

  React.useLayoutEffect(() => () => setSaveBar(null), [setSaveBar]);
};
